/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SinglePlayerStatistic = {
    properties: {
        value: {
            type: 'number',
            isRequired: true,
        },
        player: {
            type: 'PlayerMedium',
            isRequired: true,
        },
        placement: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
